import React, {useState, useEffect} from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const KPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const localFilterModel = { items:[...filterModel.items, {field:"status", operator:"equals", value:"accepted"}]}
        setLocalFilterModel(localFilterModel);
        setLocalDrawable(true);
    },[filterModel])

    const { getComparableTimeframe } = useDates();

    return (localDrawable &&
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Accettate"
                dataProviderName={'statisticsviews/item/count/opportunities/proposal'}
                filters={localFilterModel}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Costs"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                filters={{
                    items: [
                        ...(localFilterModel?.items || [])
                            .filter(item =>
                                item.field == "registered_at" ||
                                item.field === '_related_source_name' ||
                                item.field === '_related_area_name' ||
                                item.field === '_related_shop_name'
                            )
                    ]
                }}
                format='currency'
                compactformat={false}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
            />
            <KPI
                title="CPA | Costo accettata"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/proposal'}
                filters={localFilterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'full'}
                compareFilters={getComparableTimeframe(localFilterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
            />
            
        </Box>
    )
}

export default KPISet;